(function () {
  /* ================================
     CONFIG
  ================================= */
  const CART_ICON_SELECTOR = '.icon-cart, .header__icon--cart, [data-cart-icon]';
  const BADGE_SELECTOR = '.cart-count, .cart-count-bubble, .header__cart-count';
  const ACCENT_COLOR = '#FA009F';

  /* ================================
     UTILS
  ================================= */
  function waitForElement(selector, timeout = 5000) {
    return new Promise((resolve) => {
      const el = document.querySelector(selector);
      if (el) return resolve(el);

      const obs = new MutationObserver(() => {
        const el = document.querySelector(selector);
        if (el) {
          obs.disconnect();
          resolve(el);
        }
      });

      obs.observe(document.documentElement, { childList: true, subtree: true });

      setTimeout(() => {
        obs.disconnect();
        resolve(null);
      }, timeout);
    });
  }

  function animate(el, keyframes, options) {
    if (!el || !el.animate) return;
    el.animate(keyframes, options);
  }

  /* ================================
     MAIN ANIMATION
  ================================= */
  async function playCartAnimation() {
    const cartIcon = await waitForElement(CART_ICON_SELECTOR);
    const badge = document.querySelector(BADGE_SELECTOR);

    if (!cartIcon) return;

    /* 🛒 CART ICON – BOUNCE + SHAKE */
    animate(
      cartIcon,
      [
        { transform: 'scale(1) rotate(0deg)' },
        { transform: 'scale(1.25) rotate(-8deg)' },
        { transform: 'scale(1.35) rotate(8deg)' },
        { transform: 'scale(1.25) rotate(-6deg)' },
        { transform: 'scale(1) rotate(0deg)' }
      ],
      {
        duration: 650,
        easing: 'cubic-bezier(.2,.9,.2,1)'
      }
    );

    /* 🌸 FLASH ROSA */
    animate(
      cartIcon,
      [
        { boxShadow: `0 0 0 0 rgba(250,0,159,0)` },
        { boxShadow: `0 0 0 12px rgba(250,0,159,.35)` },
        { boxShadow: `0 0 0 0 rgba(250,0,159,0)` }
      ],
      {
        duration: 550,
        easing: 'ease-out'
      }
    );

    /* 🔴 BADGE – PULSE FUERTE */
    if (badge) {
      badge.style.backgroundColor = ACCENT_COLOR;

      animate(
        badge,
        [
          { transform: 'scale(1)' },
          { transform: 'scale(1.6)' },
          { transform: 'scale(1.3)' },
          { transform: 'scale(1)' }
        ],
        {
          duration: 700,
          easing: 'cubic-bezier(.34,1.56,.64,1)'
        }
      );
    }
  }

  /* ================================
     EVENTS (SHRINE COMPATIBLE)
  ================================= */

  // 1️⃣ Evento moderno (si el theme lo emite)
  document.addEventListener('cart:updated', playCartAnimation);

  // 2️⃣ Fallback: detectar Add to Cart por fetch
  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then((response) => {
      try {
        const url = arguments[0]?.toString() || '';
        if (url.includes('/cart/add')) {
          setTimeout(playCartAnimation, 150);
        }
      } catch (e) {}
      return response;
    });
  };

  // 3️⃣ Fallback extra: botones Add to Cart
  document.addEventListener('click', function (e) {
    const btn = e.target.closest(
      'button[name="add"], [data-add-to-cart], .product-form__submit'
    );
    if (btn) {
      setTimeout(playCartAnimation, 300);
    }
  });
})();

